import type { FaqTopicType } from "../components/topics-accordion/topics-accordion";
import { extractPath } from "./extract-path";

// `extractPath` is use to extract the [shop: '/gb'] from the url
// to be able to compare clean url's paths.
// Sitecore can have paths with and without '/gb' we parsed both urls
// to have clean paths and avoid scenarios of a false negative

export const findSelectedTopic = (topics: FaqTopicType[], url: string) => {
  const cleanUrl = url?.split("?")[0]?.split("#")[0]?.toLowerCase() ?? "";
  const urlPath = extractPath(cleanUrl);

  const selectedTopic = topics.find((topic) => {
    const topicUrl = topic.topicLink?.item?.url?.path.toLowerCase() || "";
    const topicPath = extractPath(topicUrl);
    if (!topicPath) return false;
    return (
      urlPath.startsWith(topicPath) &&
      (urlPath.length === topicPath.length || urlPath[topicPath.length] === "/")
    );
  });
  return selectedTopic ? selectedTopic.topicLink?.item?.url?.path : "";
};
